(() => {
  const PRODUCT_PATH = '/products/';

  function setupProductConversion() {
    if (!window.location.pathname.includes(PRODUCT_PATH)) return;

    const formButtons = document.querySelector('.product-form-buttons');
    const addButton = formButtons?.querySelector('[name="add"], button[type="submit"]');
    if (!formButtons || !addButton || document.querySelector('.dl-mobile-purchase')) return;

    const note = document.createElement('div');
    note.className = 'dl-conversion-note';
    note.innerHTML = '<strong>COD available across India.</strong> 8% advance (minimum ₹400); balance on delivery. Guest checkout available.';
    formButtons.insertAdjacentElement('afterend', note);

    const priceSource = document.querySelector('[data-block-type="price"], .price, product-price');
    const priceText = priceSource?.textContent?.replace(/\s+/g, ' ').trim() || 'Ready to order';
    const bar = document.createElement('div');
    bar.className = 'dl-mobile-purchase';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Quick purchase');
    bar.innerHTML = `
      <div class="dl-mobile-purchase__price">
        <span></span>
        <small>COD & secure payment available</small>
      </div>
      <button class="dl-mobile-purchase__button" type="button"></button>
    `;
    bar.querySelector('.dl-mobile-purchase__price span').textContent = priceText;
    document.body.appendChild(bar);

    const stickyButton = bar.querySelector('.dl-mobile-purchase__button');
    const syncButton = () => {
      stickyButton.disabled = addButton.disabled;
      stickyButton.textContent = addButton.querySelector('.add-to-cart-text__content')?.textContent?.trim()
        || (addButton.disabled ? 'Unavailable' : 'Add to cart');
    };

    stickyButton.addEventListener('click', () => {
      addButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => addButton.click(), 220);
    });

    new MutationObserver(syncButton).observe(addButton, {
      attributes: true,
      childList: true,
      subtree: true,
    });
    syncButton();

    const visibilityObserver = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && window.scrollY > 160;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('dl-mobile-purchase-active', show);
    }, { threshold: 0.15 });
    visibilityObserver.observe(formButtons);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupProductConversion, { once: true });
  } else {
    setupProductConversion();
  }
})();

